import { render, staticRenderFns } from "./GeneralSpecialtyDelete.vue?vue&type=template&id=24b7905b&scoped=true&"
import script from "./GeneralSpecialtyDelete.vue?vue&type=script&lang=js&"
export * from "./GeneralSpecialtyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7905b",
  null
  
)

export default component.exports